import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { PRICE, PRICE_BEFORE } from '../data/spremna';
const recap = ['6 томова', '5 бонуса', '240 страна', '6–16 година'];
const reassurances = ['Тренутни дигитални приступ', 'PDF спреман за штампу', '7 дана гаранције задовољства'];
export function FinalCta() {
  return <section className="relative w-full overflow-hidden bg-seyes px-8 py-24 sm:px-14 sm:py-32" data-id="element-109" data-mp="15fggqhcwiwzc">
      <div aria-hidden="true" className="pointer-events-none absolute inset-y-0 left-4 w-px bg-red-300 sm:left-8 lg:left-12" data-id="element-110" data-mp="1jb22mfnu90nj" />
      <div className="relative mx-auto max-w-3xl text-center" data-id="element-111" data-mp="1t2yaujjn275h">
        <h2 className="font-serif text-[2.6rem] leading-[1.02] tracking-tight text-slate-900 sm:text-6xl" data-id="element-112" data-mp="1t252xf8y1blr">
          Ваша сезона може бити <em className="text-red-700" data-id="element-113" data-mp="223mhuuam778v">спремна већ данас.</em>
        </h2>
        <p className="mx-auto mt-6 max-w-2xl text-lg leading-relaxed text-slate-900/75" data-id="element-114" data-mp="223wbcruvbwjb">
          Уместо да тражите вежбе, цртате дијаграме и смишљате тренинг у колима, имате готов
          пакет за целу сезону. Више времена за оно што је заиста важно:
        </p>
        <p className="mt-6 font-serif text-2xl italic leading-snug text-slate-900 sm:text-3xl" data-id="element-115" data-mp="s5qn5tc1t0sm">
          Ваши играчи. Ваша екипа. Ваш живот ван сале.
        </p>

        <ul className="mt-10 flex flex-wrap justify-center gap-x-6 gap-y-2 text-sm font-medium text-slate-900/70" data-id="element-116" data-mp="122lmgeg5b57y">
          {recap.map(item => <li key={item} data-id="element-117" data-mp="163f6gwqgvzvk">{item}</li>)}
        </ul>

        <p className="mt-8 text-lg text-slate-900/60" data-id="element-118" data-mp="1b3js1168fksn">Пре <s data-id="element-119" data-mp="1b28on2gp8f22">{PRICE_BEFORE}</s></p>
        <p className="mt-2 whitespace-nowrap font-serif text-6xl leading-none tracking-tight text-slate-900 sm:text-7xl" data-id="element-120" data-mp="1b1gqbjvpw383">{PRICE}</p>
        <p className="mt-3 text-sm text-slate-900/70" data-id="element-121" data-mp="1kt3ba7xuxgo1">Једнократна уплата – без претплате.</p>

        <div className="mt-8 flex justify-center" data-id="element-122" data-mp="1pspo4g9rwuwb">
          <CtaButton className="w-full sm:w-auto" data-id="element-123" data-mp="1pu0u8mqoyeql" />
        </div>

        <ul className="mt-6 flex flex-wrap justify-center gap-x-6 gap-y-1.5 text-sm text-slate-900/70" data-id="element-124" data-mp="1tt9m1m2682ji">
          {reassurances.map(item => <li key={item} className="flex items-center gap-2" data-id="element-125" data-mp="3qv6za7sgk24p">
              <CheckIcon className="h-4 w-4 text-red-700" aria-hidden="true" data-id="element-126" data-mp="3lwdlsfd68b4j" />
              {item}
            </li>)}
        </ul>
      </div>
    </section>;
}